import WelcomePopupAiAssistant202511 from './collection/WelcomePopupAiAssistant202511'
import useWelcomePopup from './useWelcomePopup'

function WelcomePopup() {
  const {showPopup, onClose, onCallToActionClick} = useWelcomePopup()

  return (
    <WelcomePopupAiAssistant202511
      isShowPopup={showPopup}
      onClose={onClose}
      onCallToActionClick={onCallToActionClick}
    />
  )
}
export default WelcomePopup
